import React from 'react';
function FontSize({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.33 15.303L2 18.998l.001.002.002-.001.447-1.248L6.872 5.404a.591.591 0 01.768-.365c.16.062.288.193.35.36l5.002 13.555c0 .003.003.004.005.003A.004.004 0 0013 18.95l-.996-2.72M4 14h7M15 16h5M14.384 15.243L13 18.998V19h.002l.366-1 3.51-9.598a.604.604 0 011.134-.006l3.981 10.567c.001.002.003.003.005.002a.003.003 0 00.002-.004l-1.192-3.135"
      />
    </svg>
  );
}

export default FontSize;
